module.exports = __webpack_public_path__ + "./fonts/47b9e7ea0fa868aa715ab326ac33c2c6.woff";